import { RequestStatus } from '../../configs/service'

import { IPartnerDashboardState } from './models'

export const initialState: IPartnerDashboardState = {
  isInitialized: false,
  isLoading: false,
  selectedPartnerRecord: { data: null, status: RequestStatus.FULFILLED, message: '' },
  userPartnerList: { data: [], status: RequestStatus.FULFILLED, message: '' },
  favoritePartnerList: { data: [], status: RequestStatus.FULFILLED, message: '' },
  userHistoryList: { data: [], status: RequestStatus.FULFILLED, message: '' },
}

export const MAX_HISTORY_PARTNER_LIST_SIZE = 30

export const PARTNER_HISTORY_KEY = 'partner_dashboard_history'

export const PARTNER_DASHBOARD_NAMESPACE = 'partnerDashboard'

export const INIT_PARTNER_DASHBOARD_ACTION_TYPE = `${PARTNER_DASHBOARD_NAMESPACE}/initPartnerDashboard`
